<template>

  <div class="w-full sm:w-1/2 p-[0.5rem] lg:w-1/4 lg:px-[10px] lg:py-0 lg:first:pl-0 lg:last:pr-0">
    <div class="bg-purple-100 rounded-md flex items-center w-full h-full flex-wrap p-[1.25rem] shadow-purple">
      <div class="bg-purple-200 max-w-[30%] min-w-[60px] min-h-[60px] flex items-center justify-center rounded-full h-[3.8rem] w-[3.8rem]">
        <span>
          <font-awesome-icon 
            :icon="icon" 
            class="text-white text-lg cursor-pointer" />
        </span>
      </div>

      <div class="ml-[10px] max-w-[65%]">
        <h3 class="text-base font-poppins text-white">
          {{ title }}
        </h3>

        <span class="text-xl sm:text-2xl leading-none font-semibold text-white">
          {{ value }}
        </span>
      </div>
    </div>
  </div>

</template>

<script>

export default {

  props: {
    title: {
      type: String,
      required: true,
    },

    icon: {
      type: String,
      required: true,
    },

    value: {
      required: true,
    }
  }
    
}

</script>
